import { refreshOrdersCount } from 'shared/api/orders-count-query'

import { clientApi } from '../clientApi'

import {
  CalculateInsuranceProgramsRequest,
  CalculateInsuranceProgramsResponse,
  CreateInsurancePolicyRequest,
  CreateInsurancePolicyResponse,
  InsuranceCitizenshipsResponse,
  InsuranceCountriesResponse,
  InsurancePurposesResponse,
} from './model'

export const InsuranceApi = {
  getCountries(signal?: AbortSignal) {
    return clientApi.get<InsuranceCountriesResponse>('/insurance/countries', {
      signal,
    })
  },

  getPurposes(signal?: AbortSignal) {
    return clientApi.get<InsurancePurposesResponse>('/insurance/purposes', {
      signal,
    })
  },

  calculatePrograms(
    payload: CalculateInsuranceProgramsRequest,
    signal?: AbortSignal,
  ) {
    return clientApi.post<CalculateInsuranceProgramsResponse>(
      '/insurance/calc',
      payload,
      { signal },
    )
  },

  getCitizenships(signal?: AbortSignal) {
    return clientApi.get<InsuranceCitizenshipsResponse>(
      '/insurance/citizenships',
      { signal },
    )
  },

  async createPolicy(payload: CreateInsurancePolicyRequest) {
    const response = await clientApi.post<CreateInsurancePolicyResponse>(
      '/insurance/policies',
      payload,
    )
    void refreshOrdersCount()
    return response
  },
}
